import { getDateFromTick } from "./ticks";
import { getTickFromTargetWeight, realFormula } from "./points";

export function getDateFromWeight(
  startWeight: number,
  endWeight: number,
  targetWeight: number,
  today: Date,
  endDate: Date
) {
  const tick = getTickFromTargetWeight(startWeight, endWeight, targetWeight);
  return getDateFromTick(tick, today, endDate);
}

export function getWeightFromDate(
  startWeight: number,
  idealWeight: number,
  targetDate: Date,
  endDate: Date
) {
  if (targetDate > endDate) {
    return idealWeight;
  }

  const todayTimeStamp = new Date().getTime();
  const endOfPlanTimeStamp = endDate.getTime();
  const targetDateTimeStamp = targetDate.getTime();

  const weightedXCoord =
    (targetDateTimeStamp - todayTimeStamp) /
    (endOfPlanTimeStamp - todayTimeStamp);

  const finalWeight = realFormula(weightedXCoord);
  const finalWeightAboveIdealWeight = finalWeight * (startWeight - idealWeight);

  return idealWeight + Math.round(finalWeightAboveIdealWeight);
}
